// import React, { useEffect, useRef, useState } from "react";
// import homeIcon from "../../../../assets/home_02.png";
// import docIcon from "../../../../assets/doc_02.png";

// const Map = ({ lat, lng, profId }) => {
//   const [refId, setRefId] = useState(null); // user id from localStorage
//   const mapRef = useRef(null);
//   const mapInstanceRef = useRef(null);
//   const platformRef = useRef(null);
//   const currentMarkerRef = useRef(null); // fixed marker from props
//   const liveMarkerRef = useRef(null); // live updating marker from socket
//   const socketRef = useRef(null); // socket reference

//   const pointQueueRef = useRef([]); // queue for incoming lat/lng
//   const animatingRef = useRef(false); // flag to track animation

//   console.log("profId", profId);

//   useEffect(() => {
//     const ref_id = localStorage.getItem("clgrefId");
//     setRefId(ref_id);
//   }, []);

//   // 👉 Helper: fit map to show both markers smoothly
//   const fitMapToMarkers = () => {
//     if (!mapInstanceRef.current) return;
//     if (!currentMarkerRef.current || !liveMarkerRef.current) return;

//     const currentPos = currentMarkerRef.current.getGeometry();
//     const livePos = liveMarkerRef.current.getGeometry();

//     let north = Math.max(currentPos.lat, livePos.lat);
//     let south = Math.min(currentPos.lat, livePos.lat);
//     let east = Math.max(currentPos.lng, livePos.lng);
//     let west = Math.min(currentPos.lng, livePos.lng);

//     // 🧭 Expand bounding box by a small margin (in degrees)
//     const latMargin = (north - south) * 0.3 || 0.01; // add 30% or min margin
//     const lngMargin = (east - west) * 0.3 || 0.01;

//     north += latMargin;
//     south -= latMargin;
//     east += lngMargin;
//     west -= lngMargin;

//     const expandedBox = new window.H.geo.Rect(north, west, south, east);

//     mapInstanceRef.current.getViewModel().setLookAtData(
//       {
//         bounds: expandedBox,
//         // keep small padding for UI space
//         padding: 100,
//       },
//       true // animate transition
//     );
//   };

//   // Load Here Maps
//   const loadHereMaps = () => {
//     return new Promise((resolve, reject) => {
//       if (window.H) return resolve();

//       const script = document.createElement("script");
//       script.src = "https://js.api.here.com/v3/3.1/mapsjs-core.js";
//       script.async = true;
//       script.defer = true;
//       script.onload = () => {
//         const script2 = document.createElement("script");
//         script2.src = "https://js.api.here.com/v3/3.1/mapsjs-service.js";
//         script2.async = true;
//         script2.defer = true;
//         script2.onload = () => {
//           const script3 = document.createElement("script");
//           script3.src = "https://js.api.here.com/v3/3.1/mapsjs-ui.js";
//           script3.async = true;
//           script3.defer = true;
//           script3.onload = () => {
//             const script4 = document.createElement("script");
//             script4.src = "https://js.api.here.com/v3/3.1/mapsjs-mapevents.js";
//             script4.async = true;
//             script4.defer = true;
//             script4.onload = resolve;
//             script4.onerror = reject;
//             document.body.appendChild(script4);
//           };
//           document.body.appendChild(script3);
//         };
//         document.body.appendChild(script2);
//       };
//       document.body.appendChild(script);
//     });
//   };

//   useEffect(() => {
//     loadHereMaps().then(() => {
//       if (!window.H) return;
//       if (mapInstanceRef.current) return;

//       const platform = new window.H.service.Platform({
//         apikey: "FscCo6SQsrummInzClxlkdETkvx5T1r8VVI25XMGnyY",
//       });
//       platformRef.current = platform;

//       const defaultLayers = platform.createDefaultLayers();
//       const map = new window.H.Map(
//         mapRef.current,
//         defaultLayers.vector.normal.map,
//         { center: { lat: 18.54203586384748, lng: 73.87729808634725 }, zoom: 10 }
//       );

//       new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
//       // window.H.ui.UI.createDefault(map, defaultLayers);

//       mapInstanceRef.current = map;

//       return () => {
//         if (mapInstanceRef.current) {
//           mapInstanceRef.current.dispose();
//           mapInstanceRef.current = null;
//         }
//       };
//     });
//   }, []);

//   // 👇 Create/Update fixed marker whenever lat/lng changes
//   useEffect(() => {
//     if (lat && lng && mapInstanceRef.current) {
//       console.log("Render map for:", { lat, lng, profId });

//       if (currentMarkerRef.current) {
//         mapInstanceRef.current.removeObject(currentMarkerRef.current);
//       }

//       // const icon = new window.H.map.Icon("assets/home_02.png", {
//       //   size: { w: 32, h: 32 },
//       // });

//       const icon = new window.H.map.Icon(homeIcon, {
//         size: { w: 32, h: 32 },
//       });

//       const marker = new window.H.map.Marker({ lat, lng }, { icon });
//       mapInstanceRef.current.addObject(marker);
//       currentMarkerRef.current = marker;

//       // 👇 Center/fit logic
//       if (liveMarkerRef.current) {
//         fitMapToMarkers(); // show both markers
//       } else {
//         mapInstanceRef.current.setCenter({ lat, lng });
//       }
//     }
//   }, [lat, lng, profId]);

//   // 👉 Animate live marker smoothly
//   const animateMarker = (from, to, duration = 10000) => {
//     if (!mapInstanceRef.current) return;
//     animatingRef.current = true;

//     const startTime = performance.now();

//     const step = (currentTime) => {
//       const elapsed = currentTime - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       const lat = from.lat + (to.lat - from.lat) * progress;
//       const lng = from.lng + (to.lng - from.lng) * progress;

//       if (liveMarkerRef.current) {
//         liveMarkerRef.current.setGeometry({ lat, lng });
//       } else {
//         // const icon = new window.H.map.Icon("assets/doc_02.png", {
//         //   size: { w: 32, h: 32 },
//         // });

//         const icon = new window.H.map.Icon(docIcon, {
//           size: { w: 32, h: 32 },
//         });

//         liveMarkerRef.current = new window.H.map.Marker({ lat, lng }, { icon });
//         mapInstanceRef.current.addObject(liveMarkerRef.current);

//         // 👇 First time live marker appears, fit map to show both
//         if (currentMarkerRef.current) {
//           fitMapToMarkers();
//         }
//       }

//       if (progress < 1) {
//         requestAnimationFrame(step);
//       } else {
//         animatingRef.current = false;
//         if (pointQueueRef.current.length > 1) {
//           const nextFrom = pointQueueRef.current.shift();
//           const nextTo = pointQueueRef.current[0];
//           animateMarker(nextFrom, nextTo, duration);
//         }
//       }
//     };

//     requestAnimationFrame(step);
//   };

//   // 👉 Queue updates for live marker
//   const updateLiveMarker = (latitude, longitude) => {
//     const newPoint = { lat: latitude, lng: longitude };
//     pointQueueRef.current.push(newPoint);

//     if (pointQueueRef.current.length >= 2 && !animatingRef.current) {
//       const from = pointQueueRef.current.shift();
//       const to = pointQueueRef.current[0];
//       animateMarker(from, to);
//     }
//   };

//   // 👉 Setup WebSocket connection
//   useEffect(() => {
//     if (!profId || !refId) return;

//     if (socketRef.current) socketRef.current.close();

//     const socketUrl = `wss://websocket.hospitalguru.in/ws/location/?user_id=${refId}&group_id=${profId}`;
//     const ws = new WebSocket(socketUrl);
//     socketRef.current = ws;

//     ws.onopen = () => {
//       console.log("✅ WebSocket Connected:", socketUrl);
//     };

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         if (data.latitude && data.longitude) {
//           console.log("📍 Live update:", data);
//           updateLiveMarker(data.latitude, data.longitude);
//         }
//       } catch (error) {
//         console.error("❌ Error parsing socket message:", error);
//       }
//     };

//     ws.onerror = (error) => console.error("❌ WebSocket Error:", error);
//     ws.onclose = () => console.log("🔌 WebSocket Disconnected");

//     return () => ws.close();
//   }, [profId, refId]);

//   return <div ref={mapRef} style={{ width: "100%", height: "300px" }} />;
// };

// export default Map;

// import React, { useEffect, useRef, useState, useMemo } from "react";

// import {
//   MapContainer,
//   Marker,
//   useMap,
//   GeoJSON,
//   Popup,
//   ZoomControl,
//   TileLayer,
// } from "react-leaflet";

// import "leaflet/dist/leaflet.css";
// import L from "leaflet";

// import maplibregl from "maplibre-gl"; // ⬅️ explicit import, prevents tree-shaking/runtime breakage
// import "maplibre-gl/dist/maplibre-gl.css";
// import "@maplibre/maplibre-gl-leaflet";

// import homeIconImg from "../../../../../HHC/assets/home_02.png";
// import docIconImg from "../../../../../HHC/assets/doc_03.png";
// import markerIconImg from "../../../../../HHC/assets/doctor.png";
// import MarkerClusterGroup from "react-leaflet-markercluster";

// import "leaflet.markercluster/dist/MarkerCluster.css";
// import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// // Fix default icon issue (only matters if L.Marker's default icon is ever used)
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconUrl: markerIconImg,
// });

// const marker = new L.Icon({
//   iconUrl: markerIconImg,
//   iconSize: [28, 28],
//   iconAnchor: [14, 28],
// });

// const homeIcon = new L.Icon({
//   iconUrl: homeIconImg,
//   iconSize: [28, 28],
//   iconAnchor: [14, 28],
// });

// const docIcon = new L.Icon({
//   iconUrl: docIconImg,
//   iconSize: [22, 22],
//   iconAnchor: [11, 22],
// });

// /* ---------------------------------------------------
//    Helper component to fit map to both markers
// --------------------------------------------------- */
// const MapAutoZoom = ({ homePosition, livePosition }) => {
//   const map = useMap();
//   const homeZoomedRef = useRef(false);
//   const bothZoomedRef = useRef(false);

//   useEffect(() => {
//     if (!homePosition) {
//       homeZoomedRef.current = false;
//       bothZoomedRef.current = false;
//       return;
//     }

//     if (!livePosition && !homeZoomedRef.current) {
//       map.setView(homePosition, 15, { animate: true, duration: 1 });
//       homeZoomedRef.current = true;
//     }

//     if (livePosition && !bothZoomedRef.current) {
//       const bounds = L.latLngBounds([homePosition, livePosition]);
//       map.fitBounds(bounds, {
//         padding: [100, 100],
//         animate: true,
//         duration: 1,
//       });
//       bothZoomedRef.current = true;
//     }
//   }, [homePosition, livePosition, map]);

//   return null;
// };

// const MapController = ({ mapRef }) => {
//   const map = useMap();

//   useEffect(() => {
//     mapRef.current = map;

//     // 🔑 Fix #1: force a size recalculation right after mount.
//     // If MapContainer mounts inside a flex/tab/collapsed parent, Leaflet
//     // can compute a 0x0 or stale size and never paint tiles -> white map.
//     const t1 = setTimeout(() => map.invalidateSize(), 100);
//     const t2 = setTimeout(() => map.invalidateSize(), 500);

//     const handleResize = () => map.invalidateSize();
//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(t1);
//       clearTimeout(t2);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, [map]);

//   return null;
// };

// const OpenFreeMapLiberty = () => {
//   const map = useMap();
//   const [vectorFailed, setVectorFailed] = useState(false);

//   useEffect(() => {
//     let gl;
//     let removed = false;

//     // 🔑 Fix #2: wait until the Leaflet map is actually ready
//     // (has a measured size) before attaching the GL layer.
//     map.whenReady(() => {
//       if (removed) return;

//       gl = L.maplibreGL({
//         style: "https://tiles.openfreemap.org/styles/liberty",
//         attribution:
//           '&copy; <a href="https://openfreemap.org">OpenFreeMap</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//       });

//       gl.addTo(map);

//       const maplibreMap = gl.getMaplibreMap?.();

//       if (maplibreMap) {
//         maplibreMap.on("load", () => {
//           map.invalidateSize();
//         });

//         // 🔑 Fix #3: if the vector style/network fails, fall back to
//         // a plain raster layer instead of leaving the map blank.
//         maplibreMap.on("error", (e) => {
//           console.error("MapLibre ERROR, falling back to raster tiles:", e);
//           setVectorFailed(true);
//         });

//         setTimeout(() => {
//           maplibreMap.resize();
//           map.invalidateSize();
//         }, 500);
//       } else {
//         console.error("Could not get MapLibre map instance, falling back");
//         setVectorFailed(true);
//       }
//     });

//     return () => {
//       removed = true;
//       if (gl) map.removeLayer(gl);
//     };
//   }, [map]);

//   if (vectorFailed) {
//     // Guaranteed-to-render fallback so the map is never blank
//     return (
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution="&copy; OpenStreetMap contributors"
//       />
//     );
//   }

//   return null;
// };

// const Map = ({ lat, lng, profId, mode, setSelectedMapData }) => {
//   const DEFAULT_CENTER = [18.50588695216499, 73.82093163989033];

//   const [livePosition, setLivePosition] = useState(null);
//   const [geojson, setGeojson] = useState(null);
//   const [userPositions, setUserPositions] = useState([]);
//   const [isExpanded, setIsExpanded] = useState(false);

//   const markersRef = useRef(new globalThis.Map());
//   const socketRef = useRef(null);
//   const animatingRef = useRef(false);
//   const pointQueueRef = useRef([]);
//   const mapRef = useRef(null);

//   const homePosition = useMemo(() => {
//     return mode === "live" && lat && lng ? [lat, lng] : null;
//   }, [mode, lat, lng]);

//   useEffect(() => {
//     const ws = new WebSocket("ws://192.168.1.109:8008/ws/users");

//     ws.onopen = () => console.log("✅ Users websocket connected");

//     ws.onmessage = (event) => {
//       try {
//         const records = JSON.parse(event.data);
//         if (!Array.isArray(records)) return;

//         let hasNewMarkers = false;

//         records.forEach((r) => {
//           if (!r.latitude || !r.longitude) return;
//           const id = r.agg_sp_dt_eve_poc_id;
//           if (markersRef.current.has(id)) return;

//           markersRef.current.set(id, {
//             id,
//             lat: Number(r.latitude),
//             lng: Number(r.longitude),
//             eventCode: r.eve_id_id?.event_code,
//             eventId: r.eve_id_id?.eve_id,
//             professional: r.srv_prof_id_id?.prof_fullname,
//             professionalId: r.srv_prof_id_id?.srv_prof_id,
//             service: r.service_title,
//             startDate: r.actual_StartDate_Time,
//             endDate: r.actual_EndDate_Time,
//             startTime: r.start_time,
//             endTime: r.end_time,
//             sessionStatus: r.Session_status,
//             status: r.status,
//             sub_service: r.sub_service,
//             caller_number: r.caller_number,
//             caller_name: r.caller_name,
//           });

//           hasNewMarkers = true;
//         });

//         if (hasNewMarkers) {
//           setUserPositions(Array.from(markersRef.current.values()));
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     ws.onerror = (err) => console.error("WebSocket Error:", err);
//     ws.onclose = () => console.log("🔌 Users websocket disconnected");

//     return () => ws.close();
//   }, []);

//   useEffect(() => {
//     fetch("/Pune_Zone_Boundaries.geojson")
//       .then((res) => res.json())
//       .then((data) => setGeojson(data))
//       .catch(console.error);
//   }, []);

//   const animateMarker = (from, to, duration = 10000) => {
//     animatingRef.current = true;
//     const start = performance.now();

//     const step = (time) => {
//       const progress = Math.min((time - start) / duration, 1);
//       const currentLat = from[0] + (to[0] - from[0]) * progress;
//       const currentLng = from[1] + (to[1] - from[1]) * progress;

//       setLivePosition([currentLat, currentLng]);

//       if (progress < 1) {
//         requestAnimationFrame(step);
//       } else {
//         animatingRef.current = false;
//         if (pointQueueRef.current.length > 1) {
//           const nextFrom = pointQueueRef.current.shift();
//           const nextTo = pointQueueRef.current[0];
//           animateMarker(nextFrom, nextTo);
//         }
//       }
//     };

//     requestAnimationFrame(step);
//   };

//   const updateLiveMarker = (lat, lng) => {
//     const newPoint = [lat, lng];
//     pointQueueRef.current.push(newPoint);

//     if (pointQueueRef.current.length >= 2 && !animatingRef.current) {
//       const from = pointQueueRef.current.shift();
//       const to = pointQueueRef.current[0];
//       animateMarker(from, to);
//     }
//   };

//   useEffect(() => {
//     if (mode !== "live" || !profId) return;

//     const refId = localStorage.getItem("clgrefId");
//     if (!refId) return;

//     pointQueueRef.current = [];
//     animatingRef.current = false;
//     setLivePosition(null);

//     if (socketRef.current) socketRef.current.close();

//     const wsUrl = `wss://websocket.hospitalguru.in/ws/location/?user_id=${refId}&group_id=${profId}`;
//     const ws = new WebSocket(wsUrl);
//     socketRef.current = ws;

//     ws.onopen = () => console.log("✅ WebSocket connected");

//     ws.onmessage = (e) => {
//       try {
//         const data = JSON.parse(e.data);
//         if (data.latitude && data.longitude) {
//           updateLiveMarker(data.latitude, data.longitude);
//         }
//       } catch (err) {
//         console.error("❌ Socket parse error", err);
//       }
//     };

//     ws.onclose = () => console.log("🔌 WebSocket disconnected");

//     return () => {
//       ws.close();
//       socketRef.current = null;
//     };
//   }, [mode, profId]);

//   const handleBack = () => {
//     setSelectedMapData({
//       lat: null,
//       lng: null,
//       profId: null,
//       mode: "overview",
//     });

//     setLivePosition(null);
//     pointQueueRef.current = [];
//     animatingRef.current = false;

//     if (socketRef.current) {
//       socketRef.current.close();
//     }

//     if (mapRef.current) {
//       mapRef.current.setView(DEFAULT_CENTER, 12, { animate: true });
//     }
//   };

//   const showOverview = mode === "overview";

//   useEffect(() => {
//     if (mapRef.current) {
//       setTimeout(() => {
//         mapRef.current.invalidateSize();
//       }, 100);
//     }
//   }, [isExpanded]);

//   return (
//     <div
//       style={{
//         position: isExpanded ? "fixed" : "relative",
//         top: isExpanded ? 0 : "auto",
//         left: isExpanded ? 0 : "auto",
//         width: isExpanded ? "100vw" : "100%",
//         height: isExpanded ? "100vh" : "400px",
//         zIndex: isExpanded ? 9999 : 1,
//         background: "#fff",
//       }}
//     >
//       {!showOverview && (
//         <button
//           onClick={handleBack}
//           style={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             zIndex: 1000,
//             padding: "8px 14px",
//             cursor: "pointer",
//             background: "#0a75f0",
//             color: "white",
//             border: "none",
//             borderRadius: "60px",
//           }}
//         >
//           Return to Map
//         </button>
//       )}

//       {mode === "live" && !livePosition && (
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 999,
//             background: "rgba(255,255,255,0.6)",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "10px",
//           }}
//         >
//           <div
//             style={{
//               width: "36px",
//               height: "36px",
//               border: "4px solid #9EC6F3",
//               borderTop: "4px solid transparent",
//               borderRadius: "50%",
//               animation: "spin 0.8s linear infinite",
//             }}
//           />
//           <span style={{ fontSize: "13px", color: "#333", fontWeight: 500 }}>
//             Waiting for professional's live location…
//           </span>
//           <style>
//             {`
//             @keyframes spin {
//               0% { transform: rotate(0deg); }
//               100% { transform: rotate(360deg); }
//             }
//           `}
//           </style>
//         </div>
//       )}

//       <button
//         onClick={() => setIsExpanded(!isExpanded)}
//         style={{
//           position: "absolute",
//           top: 10,
//           left: 10,
//           zIndex: 1000,
//           padding: "8px 14px",
//           cursor: "pointer",
//           background: "#0a75f0",
//           color: "white",
//           border: "none",
//           borderRadius: "60px",
//         }}
//       >
//         {isExpanded ? "Close Extend Map" : "Extend Map"}
//       </button>

//       <MapContainer
//         center={homePosition || DEFAULT_CENTER}
//         zoom={8}
//         minZoom={6}
//         attributionControl={true}
//         zoomControl={false}
//         style={{ height: "100%", width: "100%" }}
//       >
//         <OpenFreeMapLiberty />

//         <ZoomControl position="bottomleft" />
//         <MapController mapRef={mapRef} />

//         {geojson && showOverview && (
//           <GeoJSON
//             data={geojson}
//             style={() => ({
//               color: "red",
//               weight: 2,
//               fillColor: "red",
//               fillOpacity: 0.15,
//             })}
//             onEachFeature={(feature, layer) => {
//               if (feature.properties?.NAME_3) {
//                 layer.bindTooltip(feature.properties.NAME_3, {
//                   permanent: false,
//                   sticky: true,
//                   direction: "top",
//                   opacity: 0.9,
//                 });
//               }

//               layer.on({
//                 mouseover: (e) => {
//                   e.target.setStyle({
//                     weight: 3,
//                     color: "#0000ff",
//                     fillOpacity: 0.3,
//                   });
//                 },
//                 mouseout: (e) => {
//                   e.target.setStyle({
//                     weight: 2,
//                     color: "red",
//                     fillOpacity: 0.15,
//                   });
//                 },
//               });
//             }}
//           />
//         )}

//         {showOverview &&
//           userPositions.map((user) => (
//             <Marker key={user.id} position={[user.lat, user.lng]} icon={marker}>
//               <Popup minWidth={250}>
//                 <div style={{ fontSize: "13px", lineHeight: "1.5" }}>
//                   <b>{user.professional}</b>
//                   <hr style={{ margin: "6px 0" }} />
//                   <div><b>Event Code:</b> {user.eventCode}</div>
//                   <div><b>Service:</b> {user.service}</div>
//                   <div><b>sub_service:</b> {user.sub_service}</div>
//                   <div><b>caller_number:</b> {user.caller_number}</div>
//                   <div><b>caller_name:</b> {user.caller_name}</div>
//                   <div><b>Status:</b> {user.sessionStatus}</div>
//                   <div><b>Start:</b> {user.startDate} {user.startTime}</div>
//                   <div><b>End:</b> {user.endDate} {user.endTime}</div>
//                 </div>
//               </Popup>
//             </Marker>
//           ))}

//         {homePosition && <Marker position={homePosition} icon={homeIcon} />}
//         {mode === "live" && livePosition && (
//           <Marker position={livePosition} icon={docIcon} />
//         )}

//         <MapAutoZoom
//           homePosition={homePosition}
//           livePosition={mode === "live" ? livePosition : null}
//         />
//       </MapContainer>
//     </div>
//   );
// };

// export default Map;

import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  GeoJSON,
  Popup,
  ZoomControl,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import homeIconImg from "../../../../../HHC/assets/home_02.png";
import docIconImg from "../../../../../HHC/assets/doc_03.png";
import markerIconImg from "../../../../../HHC/assets/doctor.png";
import MarkerClusterGroup from "react-leaflet-markercluster";

import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// Fix default icon issue
delete L.Icon.Default.prototype._getIconUrl;

const marker = new L.Icon({
  iconUrl: markerIconImg,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
});

const homeIcon = new L.Icon({
  iconUrl: homeIconImg,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
});

const docIcon = new L.Icon({
  iconUrl: docIconImg,
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

/* ---------------------------------------------------
   👉 Helper component to fit map to both markers
   Flags now reset whenever homePosition goes back to
   null (i.e. we left "live" mode), so the very next
   time we enter live mode the zoom logic runs fresh.
--------------------------------------------------- */
const MapAutoZoom = ({ homePosition, livePosition }) => {
  const map = useMap();
  const homeZoomedRef = useRef(false);
  const bothZoomedRef = useRef(false);

  useEffect(() => {
    if (!homePosition) {
      // Left live view — reset so next entry zooms again
      homeZoomedRef.current = false;
      bothZoomedRef.current = false;
      return;
    }

    if (!livePosition && !homeZoomedRef.current) {
      map.setView(homePosition, 15, { animate: true, duration: 1 });
      homeZoomedRef.current = true;
    }

    if (livePosition && !bothZoomedRef.current) {
      const bounds = L.latLngBounds([homePosition, livePosition]);
      map.fitBounds(bounds, {
        padding: [100, 100],
        animate: true,
        duration: 1,
      });
      bothZoomedRef.current = true;
    }
  }, [homePosition, livePosition, map]);

  return null;
};

const MapController = ({ mapRef }) => {
  const map = useMap();

  useEffect(() => {
    mapRef.current = map;
  }, [map]);

  return null;
};

// const Map = ({ lat, lng, profId }) => {
const Map = ({ lat, lng, profId, mode, setSelectedMapData }) => {
  const DEFAULT_CENTER = [18.50588695216499, 73.82093163989033];

  // "overview" -> geojson + all-user markers
  // "live"     -> home marker + animated live marker
  // const [mode, setMode] = useState(lat && lng ? "live" : "overview");

  const [livePosition, setLivePosition] = useState(null);
  const [geojson, setGeojson] = useState(null);
  const [userPositions, setUserPositions] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const markersRef = useRef(new window.Map());
  const socketRef = useRef(null);
  const animatingRef = useRef(false);
  const pointQueueRef = useRef([]);
  const mapRef = useRef(null);

  // homePosition is now *derived*, not synced via a change-detecting
  // effect — so it's always correct whenever mode/lat/lng say it should be.
  const homePosition = useMemo(() => {
    return mode === "live" && lat && lng ? [lat, lng] : null;
  }, [mode, lat, lng]);

  /* -------------------------
     🌍 All-users websocket (overview markers)
     Runs once, independent of mode.
  ------------------------- */
  useEffect(() => {
    // const ws = new WebSocket("wss://websocket.hospitalguru.in/ws/users");

    const ws = new WebSocket("ws://192.168.1.109:8008/ws/users");

    ws.onopen = () => console.log("✅ Users websocket connected");

    ws.onmessage = (event) => {
      try {
        const records = JSON.parse(event.data);
        if (!Array.isArray(records)) return;

        let hasNewMarkers = false;

        records.forEach((r) => {
          if (!r.latitude || !r.longitude) return;
          const id = r.agg_sp_dt_eve_poc_id;
          if (markersRef.current.has(id)) return;

          markersRef.current.set(id, {
            id,
            lat: Number(r.latitude),
            lng: Number(r.longitude),
            eventCode: r.eve_id_id?.event_code,
            eventId: r.eve_id_id?.eve_id,
            professional: r.srv_prof_id_id?.prof_fullname,
            professionalId: r.srv_prof_id_id?.srv_prof_id,
            service: r.service_title,
            startDate: r.actual_StartDate_Time,
            endDate: r.actual_EndDate_Time,
            startTime: r.start_time,
            endTime: r.end_time,
            sessionStatus: r.Session_status,
            status: r.status,
            sub_service: r.sub_service,
            caller_number: r.caller_number,
            caller_name: r.caller_name,
          });

          hasNewMarkers = true;
        });

        if (hasNewMarkers) {
          setUserPositions(Array.from(markersRef.current.values()));
        }
      } catch (err) {
        console.error(err);
      }
    };

    ws.onerror = (err) => console.error("WebSocket Error:", err);
    ws.onclose = () => console.log("🔌 Users websocket disconnected");

    return () => ws.close();
  }, []);

  useEffect(() => {

    fetch("/Pune_Zone_Boundaries.geojson")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`GeoJSON request failed: ${res.status} ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => setGeojson(data))
      .catch((error) => console.error("Unable to load Pune zone boundaries:", error));
  }, []);

  /* -------------------------
     🎞 Smooth marker animation
  ------------------------- */
  const animateMarker = (from, to, duration = 10000) => {
    animatingRef.current = true;
    const start = performance.now();

    const step = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const currentLat = from[0] + (to[0] - from[0]) * progress;
      const currentLng = from[1] + (to[1] - from[1]) * progress;

      setLivePosition([currentLat, currentLng]);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        animatingRef.current = false;
        if (pointQueueRef.current.length > 1) {
          const nextFrom = pointQueueRef.current.shift();
          const nextTo = pointQueueRef.current[0];
          animateMarker(nextFrom, nextTo);
        }
      }
    };

    requestAnimationFrame(step);
  };

  const updateLiveMarker = (lat, lng) => {
    const newPoint = [lat, lng];
    pointQueueRef.current.push(newPoint);

    if (pointQueueRef.current.length >= 2 && !animatingRef.current) {
      const from = pointQueueRef.current.shift();
      const to = pointQueueRef.current[0];
      animateMarker(from, to);
    }
  };

  /* -------------------------
     🔌 Live-tracking websocket
     Keyed on `mode` as well as `profId`, so re-entering
     "live" mode always reconnects & resets — even if
     profId didn't change from last time.
  ------------------------- */
  useEffect(() => {
    if (mode !== "live" || !profId) return;

    const refId = localStorage.getItem("clgrefId");
    if (!refId) return;

    // fresh state every time we (re)enter live mode
    pointQueueRef.current = [];
    animatingRef.current = false;
    setLivePosition(null);

    if (socketRef.current) socketRef.current.close();

    const wsUrl = `wss://websocket.hospitalguru.in/ws/location/?user_id=${refId}&group_id=${profId}`;
    const ws = new WebSocket(wsUrl);
    socketRef.current = ws;

    ws.onopen = () => console.log("✅ WebSocket connected");

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.latitude && data.longitude) {
          updateLiveMarker(data.latitude, data.longitude);
        }
      } catch (err) {
        console.error("❌ Socket parse error", err);
      }
    };

    ws.onclose = () => console.log("🔌 WebSocket disconnected");

    return () => {
      ws.close();
      socketRef.current = null;
    };
  }, [mode, profId]);

  const handleBack = () => {
    setSelectedMapData({
      lat: null,
      lng: null,
      profId: null,
      mode: "overview",
    });

    setLivePosition(null);

    pointQueueRef.current = [];

    animatingRef.current = false;

    if (socketRef.current) {
      socketRef.current.close();
    }

    if (mapRef.current) {
      mapRef.current.setView(DEFAULT_CENTER, 12, {
        animate: true,
      });
    }
  };

  const showOverview = mode === "overview";

  useEffect(() => {
    if (mapRef.current) {
      setTimeout(() => {
        mapRef.current.invalidateSize();
      }, 100);
    }
  }, [isExpanded]);

  return (

    // <div style={{ height: "400px", width: "100%", position: "relative" }}>

    <div
      style={{
        position: isExpanded ? "fixed" : "relative",
        top: isExpanded ? 0 : "auto",
        left: isExpanded ? 0 : "auto",
        width: isExpanded ? "100vw" : "100%",
        height: isExpanded ? "100vh" : "400px",
        zIndex: isExpanded ? 9999 : 1,
        background: "#fff",
      }}
    >
      {!showOverview && (
        <button
          onClick={handleBack}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1000,
            padding: "8px 14px",
            cursor: "pointer",
            background: "#0a75f0",
            color: "white",
            border: "none",
            borderRadius: "60px",
          }}
        >
          Return to Map
        </button>
      )}

      {/* 👇 Loader: shows only in live mode, until professional's position arrives */}
      {mode === "live" && !livePosition && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              border: "4px solid #9EC6F3",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <span style={{ fontSize: "13px", color: "#333", fontWeight: 500 }}>
            Waiting for professional's live location…
          </span>
          <style>
            {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
          </style>
        </div>
      )}
      {/* <button
//  onClick={handleBack}
    style={{
      position: "absolute",
      top: 10,
      left: 10,
      zIndex: 1000,
      padding: "8px 14px",
      cursor: "pointer",
      background: "#0a75f0",
      color: "white",
      border: "none",
      borderRadius: "60px",
    }}
  >
  Extend Map
</button> */}

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          zIndex: 1000,
          padding: "8px 14px",
          cursor: "pointer",
          background: "#0a75f0",
          color: "white",
          border: "none",
          borderRadius: "60px",
        }}
      >
        {isExpanded ? "Close Extend Map" : "Extend Map"}
      </button>

      <MapContainer
        center={homePosition || DEFAULT_CENTER}
        zoom={8}
        minZoom={6}
        attributionControl={false}
        zoomControl={false}
        style={{ height: "100%", width: "100%" }}
      >
        {/* <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" /> */}

        <TileLayer
  url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
  maxZoom={20}
  subdomains={["mt0", "mt1", "mt2", "mt3"]}
/>

        <ZoomControl position="bottomleft" />
        <MapController mapRef={mapRef} />

        {geojson && showOverview && (
          <GeoJSON
            data={geojson}
            style={() => ({
              color: "red",
              weight: 2,
              fillColor: "red",
              fillOpacity: 0.15,
            })}
            onEachFeature={(feature, layer) => {
              if (feature.properties?.NAME_3) {
                layer.bindTooltip(feature.properties.NAME_3, {
                  permanent: false,
                  sticky: true,
                  direction: "top",
                  opacity: 0.9,
                });
              }

              layer.on({
                mouseover: (e) => {
                  e.target.setStyle({
                    weight: 3,
                    color: "#0000ff",
                    fillOpacity: 0.3,
                  });
                },
                mouseout: (e) => {
                  e.target.setStyle({
                    weight: 2,
                    color: "red",
                    fillOpacity: 0.15,
                  });
                },
              });
            }}
          />
        )}

        {showOverview &&
          userPositions.map((user) => (
            <Marker key={user.id} position={[user.lat, user.lng]} icon={marker}>
              <Popup minWidth={250}>
                <div style={{ fontSize: "13px", lineHeight: "1.5" }}>
                  <b>{user.professional}</b>
                  <hr style={{ margin: "6px 0" }} />
                  <div>
                    <b>Event Code:</b> {user.eventCode}
                  </div>
                  <div>
                    <b>Service:</b> {user.service}
                  </div>
                  <div>
                    <b>sub_service:</b> {user.sub_service}
                  </div>
                  <div>
                    <b>caller_number:</b> {user.caller_number}
                  </div>
                  <div>
                    <b>caller_name:</b> {user.caller_name}
                  </div>
                  <div>
                    <b>Status:</b> {user.sessionStatus}
                  </div>
                  <div>
                    <b>Start:</b> {user.startDate} {user.startTime}
                  </div>
                  <div>
                    <b>End:</b> {user.endDate} {user.endTime}
                  </div>

                  {/* <div><b>Latitude:</b> {user.lat}</div>
                <div><b>Longitude:</b> {user.lng}</div> */}
                </div>
              </Popup>
            </Marker>
          ))}

        {homePosition && <Marker position={homePosition} icon={homeIcon} />}
        {mode === "live" && livePosition && (
          <Marker position={livePosition} icon={docIcon} />
        )}

        <MapAutoZoom
          homePosition={homePosition}
          livePosition={mode === "live" ? livePosition : null}
        />
      </MapContainer>
    </div>
  );
};

export default Map;
